import { withAreaPrefix } from './area-routes';

/**
 * Ordered list of app routes with required scope for "first allowed route" after login.
 * Order matches current SaaS sidebar and router.
 */
export const ROUTES_WITH_SCOPE: ReadonlyArray<{ path: string; requiredScope: string }> = [
  { path: '/admin/dashboard', requiredScope: 'dashboard:read' },
  { path: '/admin/tenant/users', requiredScope: 'tenant-user:read' },
  { path: '/admin/tenant/my-product', requiredScope: 'product:read' },
  { path: '/admin/tenant/my-product', requiredScope: 'plan:read' },
  { path: '/admin/tenant/projects', requiredScope: 'project:read' },
  { path: '/admin/products', requiredScope: 'product:read' },
  { path: '/admin/projects', requiredScope: 'project:read' },
  { path: '/admin/plans', requiredScope: 'plan:read' },
  { path: '/admin/tenants', requiredScope: 'tenant:manage' },
  { path: '/admin/subscriptions', requiredScope: 'subscription:read' },
  { path: '/admin/tenant-users', requiredScope: 'tenant-user:read' },
  { path: '/admin/settings/users', requiredScope: 'user:read' },
  { path: '/admin/settings/roles', requiredScope: 'role:read' },
  { path: '/admin/settings/permissions', requiredScope: 'role:read' },
  { path: '/admin/settings/project-config', requiredScope: 'project:read' },
  { path: '/admin/settings/service-accounts', requiredScope: 'service-account:read' },
  { path: '/admin/settings/desktop-releases', requiredScope: 'desktop_release:read' },
  { path: '/admin/settings/desktop-plugins', requiredScope: 'desktop_plugin:read' },
  { path: '/admin/settings/payment-accounts', requiredScope: 'payment-account:read' },
  { path: '/admin/settings/system', requiredScope: 'settings:read' },
  { path: '/admin/settings/audit-logs', requiredScope: 'settings:read' },
];

const UNAUTHORIZED_PATH = '/unauthorized';
const ADMIN_PREFIX = '/admin';

function toTenantPath(path: string): string {
  return path.startsWith(ADMIN_PREFIX) ? path.slice(ADMIN_PREFIX.length) || '/' : path;
}

function withUserArea(path: string, pathname: string, isPlatformUser?: boolean): string {
  if (path === '/unauthorized' || path.startsWith('/auth/')) return path;
  if (isPlatformUser) return path.startsWith('/admin') ? path : `/admin${path}`;
  return withAreaPrefix(toTenantPath(path), pathname);
}

/**
 * Returns the first route the user is allowed to access, or `/unauthorized` if none.
 * Use after login to redirect to a page the user has permission for instead of always /dashboard.
 */
export function getFirstAllowedRoute(
  hasScope: (scope: string) => boolean,
  pathname = '/',
  isPlatformUser?: boolean
): string {
  for (const { path, requiredScope } of ROUTES_WITH_SCOPE) {
    if (hasScope(requiredScope)) return withUserArea(path, pathname, isPlatformUser);
  }
  // Tenant users should still land on tenant dashboard even when scope seeds are incomplete.
  if (!isPlatformUser) {
    return withUserArea('/dashboard', pathname, false);
  }
  return withUserArea(UNAUTHORIZED_PATH, pathname, isPlatformUser);
}
